module.exports = __webpack_public_path__ + "static/media/cloud1.ef95294a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Clouds/cloud1.svg
// module id = 528
// module chunks = 0